var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventHandler } from "../../interaction/eventhandler";
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent(options) {
        this.options = __assign({ enabled: true, class: "" }, options);
        this.options.click = EventHandler.Create(this.options.click);
    }
    Object.defineProperty(ButtonComponent.prototype, "click", {
        get: function () {
            return this.options.click;
        },
        enumerable: false,
        configurable: true
    });
    ButtonComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    ButtonComponent.prototype.render = function () {
        return {
            tag: "button",
            attr: {
                class: "jsl-button " + (this.options.outlined ? "jsl-button-outline " : "") +
                    this.options.class + (!this.options.enabled ? " disabled" : ""), style: this.options.style, click: this.raiseEvent
            },
            content: typeof this.options.content === "string" ? this.options.content : "",
            children: typeof this.options.content !== "string" ? [this.options.content] : []
        };
    };
    ButtonComponent.prototype.raiseEvent = function (evt) {
        if (this.options.enabled) {
            this.options.click.notify(evt);
        }
    };
    return ButtonComponent;
}());
export { ButtonComponent };
